<div class="quick-search">
  <aa-quick-search-word [storageKey]="'/admin/impersonate/popin/entity'"
  (qsWordChanged)="onQsWordChanged($event)"></aa-quick-search-word>
</div>
@if (!(isLoading | async) && isEmpty | async) {
  <div class="multi-zone"
    >
    <aa-lack-of-data [title]="'ADMIN.LIST.LACKOFDATA.TITLE' | translate"
      [message]="">
    </aa-lack-of-data>
  </div>
}
@if (isLoading | async) {
  <div class="multi-zone"
    >
    <aa-spinning-loader-alt [loading]="isLoading | async"
      [size]="2"
      [color]="1">
    </aa-spinning-loader-alt>
  </div>
}
@if (!(isEmpty | async) && (isLoaded | async)) {
  <div class="multi-zone"
    >
    <cdk-virtual-scroll-viewport itemSize="30"
      class="virtual-scrollable-viewport aa-scrollable-y aa-scrollbar">
      <aa-impe-entity-item *cdkVirtualFor="let entity of entities; let idx = index; trackBy: entityIdTrackFn; first as isFirst; last as isLast"
        [entity]="entity"
        [firstItem]="isFirst"
        [lastItem]="isLast"
        [isSelected]="entity.id === (selectedId | async)">
      </aa-impe-entity-item>
    </cdk-virtual-scroll-viewport>
  </div>
}